export const isCrmHost =
  window.location.hostname === 'crm.localhost' ||
  window.location.hostname === 'crm.kollabhr.com' ||
  window.location.hostname === 'staging-crm.kollabhr.com';
/** Mirrors the server: company mailboxes only; membership is checked there. */
export const hasCrmAccess = (email?: string) =>
  ['goklaim.com', 'kollabhr.com', 'koverhoop.com'].includes(
    email?.trim().toLowerCase().split('@')[1] ?? ''
  );
export const CRM_SOURCES = [
  'inbound',
  'outreach',
  'broker',
  'hr_consultant',
  'referral',
  'paid_acquisition',
];
export const CRM_STAGES = [
  'new',
  'contacted',
  'qualified',
  'proposal',
  'won',
  'lost',
];
export const CRM_SIZES = [
  'unknown',
  '1-9',
  '10-49',
  '50-199',
  '200-499',
  '500-999',
  '1000+',
];
